import React, { useState, useEffect } from "react";
import axios from "axios";

import Spinner from "./Spinner/Spinner"
import SingleQuote from "./SingleQuote"

const RandomQuote = () => {
  const [quote, setQuote] = useState([]);
  const [keywords, setKeywords] = useState([]);

  const [loading, setLoading] = useState(false);

  const fetchQuote = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_STOIC_QUOTE_RANDOM}`
      );
      setQuote(response.data[0]);
      setKeywords(response.data[0].keywords)
      setLoading(false);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    fetchQuote();
  }, []);

  if(loading) {
    return (<div><Spinner/></div>)
  } else {
    return (
      <div className="sm:mb-10 md:mb-12">
        <div className="flex justify-center">
          <button
            onClick={() => fetchQuote()}
            className="mb-10 bg-purple-500 hover:bg-purple-700 hover:border-purple-700 mt-3 text-white font-bold py-2 px-4 rounded"
          >
            Click me!
          </button>
        </div>
        <SingleQuote singleQuote={quote} singleQuoteKeywords={keywords}/>
      </div>
    );
  }
};

export default RandomQuote;
